export default __webpack_public_path__ + "images/e6aed9150f89494d7b72179879ffce0f.png";